<template>
	<div class="contribution-success">
		<!-- Content -->
		<div class="container">
      <div v-if="!contribution.user">
        <h3>Content visible only to contribution owners.</h3>
      </div>
      <div v-else>
        <h3>{{ $t('thank_you') + ', ' + contribution.user.full_name }}</h3>
        <br/>
        <h4>{{ $t('contribution.success.content') }}</h4>
        <h3>{{ $t('contribution.success.yourSupport') + ": " + (contribution.amount / 100) + ' ' + contribution.project.currency }}</h3>
        <h3>{{ contribution.project.title }}</h3>
        <br>
        <h3 class="mb-50">THX</h3>
        <router-link :to='contribution.project.crowdfunding ? `/crowdfunding/${contribution.project.id}/${contribution.project.title}` : `/fundraising/${contribution.project.id}/${contribution.project.title}`'
          :class="`btn btn-default btn-lg button-wide-` + crowd_or_rais"> {{ $t('contribution.success.back') }}</router-link>
      </div>
    </div>
    <crowd-or-rais></crowd-or-rais>
	</div>
</template>

<script>
import CrowdOrRais from '@/components/CrowdOrRais';
import contributionsApi from '@/api/v1/contributions';

export default {
  components: { CrowdOrRais },
  data() {
    return {
      contribution: {},
    };
  },
  computed: {
    crowd_or_rais() {
      return this.contribution.project.crowdfunding ? 'crowd' : 'rais';
    },
  },
  created() {
    contributionsApi.show(this.$route.query.transactionId, (contribution) => { this.contribution = contribution; });
  },
};
</script>



// WEBPACK FOOTER //
// ContributionSuccess.vue?abb1065a